import { useDataProvider } from '@ui-framework/index';

const useAddressValidation = () => {
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { get, getApiUrl } = useDataProvider(provider);

  const createSession = async () => {
    const result = await get(
      `${getApiUrl()}/sxcl/v1/geocoding/generate-session-token`,
    );
    if (result.ok) {
      return result?.data?.sessionToken;
    }
    return null;
  };

  const getAddress = async ({ query, sessionToken }) => {
    const result = await get(
      `${getApiUrl()}/sxcl/v1/geocoding/autocomplete-address?partialAddress=${encodeURIComponent(
        query,
      )}&sessionToken=${sessionToken}`,
    );
    return result;
  };
  return { createSession, getAddress };
};

export default useAddressValidation;
